<template>
  <div class="app-container">
    <!-- 待发货订单 -->
    <el-tabs v-model="tabName" type="card" @tab-click="handleClick">
      <el-tab-pane label="待发货通知单" name="todo">
        <todo-list ref="todoList">
          <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
            <el-button type="danger" @click="delRows">删除</el-button>
          </template>
          <template slot="column">
            <el-table-column label="操作" fixed="right" align="center" width="130">
              <template slot-scope="{row}">
                <el-button type="text" @click="details(row)">查看</el-button>
                <el-button type="text" @click="update(row)" v-if="$permission.canWrite()">发货</el-button>
                <el-button type="text" @click="onPrint(row)">打印</el-button>
              </template>
            </el-table-column>
          </template>
        </todo-list>
      </el-tab-pane>
      <!-- 发货通知单 -->
      <el-tab-pane label="已发货通知单" name="info">
        <info-list ref="infoList">
          <template slot="column">
            <el-table-column label="操作" fixed="right" align="center" width="200">
              <template slot-scope="{row}">
                <el-button type="text" @click="details(row)">查看</el-button>
                <el-button type="text" @click="onPrint(row)">打印</el-button>
                <el-button type="text" @click="createBill(row)" v-if="$permission.canWrite()">生成销货单</el-button>
                <el-button type="text" @click="update(row)" v-if="$permission.canWrite()">取消</el-button>
              </template>
            </el-table-column>
          </template>
        </info-list>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import todoList from "@/components/business/sales/deliveryrelease/todo/list";
import infoList from "@/components/business/sales/deliveryrelease/info/list";

export default {
  name: "delivery",
  mixins: [curdMixins],
  components: {
    todoList,
    infoList,
  },
  data() {
    return {
      api: require("@/api/sa/deliveryDoc").default,
      tabName: "todo",
    };
  },
  methods: {
    handleClick() {
      this.reload();
    },
    reload() {
      this.$nextTick(() => {
        if(this.tabName == "todo") this.$refs.todoList.reload();
        else this.$refs.infoList.reload();
      })
    },
    onPrint(row) {
      let newpage = this.$router.resolve({
        path: "/deliveryPrint?id=" + row.DeliveryDocId,
      });
      window.open(newpage.href, "_blank");
    },
    create(row) {
      this.$router.push({name:'editdeliveryOrder',params:{mode:"create"}})
    },
    details(row) {
      this.$router.push({name:'editdeliveryOrder', params:{mode:"edit",data:row}})
    },
    update(row) {
      this.$confirm("确认操作吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.updateDeliveryStatus({ DeliveryDocId: row.DeliveryDocId, DeliveryStatus : row.DeliveryStatus ==0?1:0 }).then(res => {
            if(res.Code==0) {
              this.reload();
              this.$message.success(res.Msg);
            } else this.$message.error(res.Msg);
          })
        })
        .catch(() => { });
    },
    //生成销货单
    createBill(row) {
      this.$confirm("确认生成销货单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.buildSaDoc(row.DeliveryDocId).then(res => {
            if(res.Code==0) {
              this.reload();
              this.$message.success(res.Msg);
            } else {
              this.$message.error(res.Msg);
            }
          })
        })
        .catch(() => { });
    },
    delRows() {
      let rows = this.$refs.todoList.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.DeliveryDocId;
          });
          this.$refs.todoList.delRange(ids);
        })
        .catch(() => { });
    },
  },
};
</script>